/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2017, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../lib/@waca/dashboard-common/dist/ui/WidgetBase'
], function (BaseWidget) {
	'use strict';

	/**
	 * Base widget for any analytics relatee widget. (e.g. liveWidget, fitlerWidget)
	 *
	 */
	var AnalyticsBaseWidget = BaseWidget.extend({

		init: function() {
			AnalyticsBaseWidget.inherited('init', this, arguments);

			var internalDashboardFeature = this.dashboardApi.getFeature('internal');
			if (internalDashboardFeature) {
				this.boardModel = internalDashboardFeature.getBoardModel();
				if (this.boardModel.pageContext) {
					this.pageContextAPI = this.boardModel.pageContext.getAPI();
				}
			}
		},

		getDashboardApi: function(){
			return this.dashboardApi;
		},

		_updateEventGroupIdInPageContext: function(newChannelId, options) {
			if (this.pageContextAPI) {
				this.pageContextAPI.updateEventGroupId(this.id, this.getContainerPageId(), newChannelId, options);
			}
		},

		onRemoveCurrentEventRouter: function(options){
			this._updateEventGroupIdInPageContext(null, options);
		},

		onNewEventRouter: function(options){
			this._updateEventGroupIdInPageContext(this.eventRouter.channelId, options);
		}
	});

	return AnalyticsBaseWidget;
});
